export const getters = {

  has_selected_objectives_services: state => state.hasSelectedObjectivesServices,

  can_display_goals: state => !!state.options.entity,
  can_display_objectives_services: state => !!state.options.goal,
  can_display_locations: state => state.hasSelectedObjectivesServices && state.goLocationsClicked,
  can_display_durations: state => state.hasSelectedLocations && state.goDurationsClicked,
  can_display_summary: state => !!state.options.duration,

  inputs: state => state.options,

  entity: state => state.options.entity || '',
  goal: state => state.options.goal || '',

  step2_structure: state => state.structure.step2 || {},
  step4_structure: state => state.structure.step4 || {},
  summary_structure: state => state.structure.summary || {},

  audience: state => state.summary.audience || {}
}

export default {
  structure: {},
  options: {
    entity: undefined,
    goal: undefined,
    objectives_services: [],
    locations: {
      cities: [],
      countries: []
    },
    duration: undefined,
    features: []
  },
  summary: {
    entity: '',
    goal: '',
    objectives_services: [],
    locations: '',
    duration: '',
    audience: {}
  },
  hasSelectedObjectivesServices: false,
  hasSelectedLocations: false,
  goLocationsClicked: false,
  goDurationsClicked: false
}
